import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import 'antd/dist/antd.min.css'; 
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'swiper/css';

import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/custom.css';



import { Provider } from 'react-redux';
import { configureStore } from './redux/store';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
     <BrowserRouter>
     <Provider store={configureStore()}>
     <App />
     </Provider>
       
        {/* app.use(express.static(__dirname)); 

app.get("/*", function(req, res) {
  res.sendFile(path.join(__dirname, "index.html"));
}); */}
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
